import React, { useCallback, useEffect, useRef, useState } from 'react';
import Card from '../../ui/Card';
import ReactPaginate from 'react-paginate';
import { useToken, WalletService } from '../../../services';

import Alert from '../../ui/Alert';
import StateView from '../../ui/StateView';
import { formatMoney, formatDate } from '../../../util';

import './styles.css';
import { STATUS } from './mapped';
import Tag from '../../ui/Tag';

function Listing({ update }) {
  const refUpdate = useRef(null);
  const { getToken } = useToken();
  const refSetState = useRef(true);
  const [states, setStates] = useState({
    msg: 'Erro ao consultar dados',
    items: [],
    error: true,
    totalPages: 0,
    pageNumber: 0,
    loading: false,
  });

  const handleNavigation = useCallback(async ({ selected }) => {
    setStates(stt => ({...stt, loading: true }));
    console.log('executou');

    let msg = '';
    let items = [];
    let error = false;
    let totalPages = 0;

    try {
      const token = await getToken();
      const params = {
        token,
        limit_page: 10,
        sort_by: 'DESCENDING',
        offset_page: selected,
        order_by: 'created_at',
      };

      const result = await WalletService.listDeposits(params);

      if (result.error) {
        throw new Error(result.msgError);
      }

      items = result.data;
      totalPages = result['pagination']['total_pages'] || 0;
    } catch (err) {
      error = true;
      if (err instanceof Error) {
        msg = err.message.slice(0, 80);
      }
    } finally {
      refUpdate.current = true;

      if (refSetState.current) {
        setStates({ 
          msg, 
          items, 
          error,
          totalPages,
          loading: false,
          pageNumber: selected,
        });
      }
    }
  }, []);

  const getTag = useCallback((key) => {
    try {
      const item = STATUS[key];
      if (!item) {
        throw new Error('');
      }

      return <Tag title={item['title']} className={item['color']} />;
    } catch (error) {
      return <Tag title="Não definido" />;
    }
  }, []);

  const getValidDate = useCallback((date) => {
    return String(date).split('.')[0];
  }, []);

  useEffect(() => {
    refSetState.current = true;

    if (refUpdate.current !== null) {
      handleNavigation({ selected : 0 });
    }

    return () => {
      refSetState.current = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [update]);

  return (
    <Card title="Aportes" className="wa-listing">
      <StateView
        error={states.error}
        loading={states.loading}
        viewLoading={
          <div className="listing__body">
            <div className="loading">
              {Array.from({ length: 5 }, (v, k) => k).map(
                (item) => (
                  <div key={item}></div>
                ),
              )}
            </div>
          </div>
        }
        viewError={
          <div className="listing__body">
            <Alert
              msg={states.msg} 
              error={states.error}
              onClose={() => {
                setStates(stt => ({...stt, enableMsg: false }));
              }}
            />
          </div>
        }
      >
        <table className="listing__table">
          <thead>
            <tr>
              <th>
                Valor
              </th>
              <th>
                Data criação
              </th>
              <th>
                Data atualização
              </th>
              <th>
                Status
              </th>
            </tr>
          </thead>
          <tbody>
            {states.items.map(item => (
              <tr key={item['id']}>
                <td>
                  <i>Valor</i>
                  {formatMoney(item['amount'])}
                </td>
                <td>
                  <i>Data criação</i>
                  {formatDate(getValidDate(item['created_at']))}
                </td>
                <td>
                  <i>Data atualização</i>
                  {formatDate(getValidDate(item['updated_at']))}
                </td>
                <td>
                  <i>Status</i>
                  {getTag(item['status'])}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </StateView>
      <div className="listing__footer">
        <ReactPaginate
          initialPage={0}
          breakLabel={'...'}
          pageRangeDisplayed={3}
          marginPagesDisplayed={2}
          activeClassName="active"
          pageClassName='page-item'
          nextClassName='page-item'
          breakClassName={'break-me'}
          pageCount={states.totalPages}
          pageLinkClassName='page-link'
          nextLinkClassName='page-link'
          previousClassName='page-item'
          forcePage={states.pageNumber}
          onPageChange={handleNavigation}
          previousLinkClassName='page-link'
          nextLabel={<i className="fas fa-angle-right" />}
          previousLabel={<i className="fas fa-angle-left" />}
          containerClassName="pagination justify-content-end mb-0"
        />
      </div>
    </Card>
  );
}

export default Listing;


// WEBPACK FOOTER //
// ./src/components/Pages/Wallet/components/functional/Listing/index.js